import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Button } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";

import api from '../../services/apiIdz';

// Components
import Navbar from "../../components/Navbar";
import Alerts from '../../components/Alerts';
import Searce from '../../components/Veiculos/Searce';
import Filter from '../../components/Veiculos/Filter';
import ModalDelete from '../../components/Importacoes/ModalDelete';

// Styles
import './Veiculos.scss';
import logo from '../Dashboard/img/logo-idzcar.png';

function Importacoes() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const navigate = useNavigate();

  const [menu, setMenu] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [importacoes, setImportacoes] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');

  const [isVisible, setIsVisible] = useState(false);
  const [isTitle, setTitle] = useState('');
  const [initDescription, setDescription] = useState('');
  const [initType, setType] = useState('');

  const handleAlert = (title, description, type) => {
    setIsVisible(true);
    setTitle(title);
    setDescription(description);
    setType(type);
  };

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => setIsVisible(false), 6000);
    }
  }, [isVisible]);

  const getImportacoes = async () => {
    try {
      const res = await api.get(`/api/importacao`, {
        headers: {
          'Authorization': process.env.REACT_APP_API_KEY
        }
      });
      console.log("res.data", res.data);
      if (Array.isArray(res.data)) {
        setImportacoes(res.data);
        setFiltered(res.data);
      }
    } catch (error) {
      console.error("Erro ao buscar importações", error);
    }
  };

  useEffect(() => {
    getImportacoes();
  }, []);

  const handleSearch = (term) => {
    setSearch(term.toLowerCase());
  };

  useEffect(() => {
    // Só aplica o filtro se search estiver preenchido
    if (search.trim() !== '') {
      const result = importacoes.filter(item =>
        item.model?.toLowerCase().includes(search)
      );
      setFiltered(result);
    } else {
      setFiltered(importacoes);
    }
  }, [search]);

  const handleShowDeleteModal = (id) => {
    setDeleteId(id);
    setShowDelete(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setShowDelete(false);
  };

  const handleCloseDeleteModalSuccess = () => {
    setDeleteId(null);
    setShowDelete(false);
    getImportacoes();
  };

  const getImageSrc = (imagem) => {
    if (!imagem || imagem === 'null') return '/img/sem-imagem.jpg';
    return `${process.env.REACT_APP_API_URL}${imagem}`;
  };

  return (
    <>
      {isVisible && <Alerts title={isTitle} description={initDescription} type={initType} />}
      <Navbar menu={menu} handleMenuToggle={() => setMenu(!menu)} />
      <div className="Content Veiculos">
        <Container fluid>
          <Row>
            <Col xs={12}>
              {isMobile ? (
                <div className='HeaderDashboard'>
                  <a href='/dashboard' className='logo'><img src={logo} alt="logo" /></a>
                  <a className='menu' onClick={() => setMenu(!menu)}><Icon icon="jam:menu" /></a>
                </div>
              ) : (
                <div className='HeaderLeads'>
                  <i><Icon icon="mdi:truck-import" /></i>
                  <h2>Importações <br /><span>Gerencie os veículos importados</span></h2>
                </div>
              )}
            </Col>
          </Row>

          <Row>
            <div className='tableVeiculos'>
              <Row>
                <Col md={6}><Searce handleSearch={handleSearch} /></Col>
                <Col md={6}>
                  <div className='actionsVeiculos'>
                    <Filter handleStatus={setStatus} />
                    <Button className='Btns New' onClick={() => navigate("/importacoes/novo")}>
                      Novo <i><Icon icon='ri:add-fill' /></i>
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <div className='listVeiculos'>
                    <Row>
                      {filtered.map((car, idx) => (
                        <Col xs={6} sm={12} md={3} lg={3} key={idx}>
                          <div className='Veiculo'>
                            <div className='imagem'>
                              {car.status && <span><i></i> {car.status}</span>}
                                <img
                                  className='thumbnail'
                                  src={getImageSrc(car.coverImage)}
                                  alt={car.model}
                                />
                            </div>
                            <h2>{car.model} {car.version && `- ${car.version}`}</h2>
                            <h6>{car.manufactureYear} / {car.productionYear}</h6>
                            <p>{car.description}</p>
                            <hr />
                            <h3>
                              <span>Valor</span> R$ {parseFloat(car.price).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2
                              })}
                            </h3>
                            <div className='acoes'>
                              <button className='Btns ButtonPrimary' onClick={() => navigate(`/importacoes/editar/${car.id}`)}>Editar</button>
                              <button className='Btns ButtonIcon' onClick={() => handleShowDeleteModal(car.id)}>
                                <i><Icon icon="mdi:trash" /></i>
                              </button>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>
        </Container>

        <ModalDelete
          deleteId={deleteId}
          getVeiculos={getImportacoes}
          show={showDelete}
          handleClose={handleCloseDeleteModal}
          handleCloseDeleteModalSuccess={handleCloseDeleteModalSuccess}
          handleAlert={handleAlert}
        />

        <ReactTooltip id="my-tooltip-delete" place="bottom" content="Deletar" style={{ backgroundColor: "#FFFFFF", color: "#000000" }} />
      </div>
    </>
  );
}

export default Importacoes;
